module.exports = __webpack_public_path__ + "static/media/hero__rules.822f2ad3.jpg";